// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"818e56e9","389":"4b371749","797":"0563963e"}[chunkId] + ".chunk.js";
};